



































































import { Vue, Component, Prop } from "vue-property-decorator";
import { validate, format } from "rut.js";

@Component
export default class Reset extends Vue {
  store = this.$store.direct;

  valid = false;

  form = {
    email: ""
  };

  rules = {
    required: (v: string) => (v && v.length > 0) || "Campo requerido",
    min: (v: string) => v.length > 6 || "Mínimo 6 carácteres"
  };

  async reset() {
    let result = await this.store.dispatch.session.reset(this.form.email);
    if (result.error) {
      this.store.commit.PUSH_MESSAGE({
        message: "El correo electrónico no es correcto",
        type: "error"
      });
    } else {
      this.store.commit.PUSH_MESSAGE({
        message:
          "Se ha enviado la contraseña temporal a " +
          this.form.email.toString(),
        type: "success"
      });
      this.$router.push({ path: "/" });
    }
  }
}
